/**
 * Aykah cart drawer
 * Figma: "Cart drawer — FINAL (styled, compact rows)"
 */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var toggleBtn = document.getElementById('cart-drawer-toggle');
  if (!drawer || !toggleBtn || drawer.dataset.cartDrawerBound === 'true') return;
  drawer.dataset.cartDrawerBound = 'true';

  var closeBtn = document.getElementById('cart-drawer-close');
  var countEl = document.getElementById('cart-drawer-count');
  var emptyEl = document.getElementById('cart-drawer-empty');
  var itemsEl = document.getElementById('cart-drawer-items');
  var loadingEl = document.getElementById('cart-drawer-loading');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var badgeEl = document.getElementById('cart-drawer-badge');
  var thresholdEl = document.getElementById('cart-drawer-threshold');
  var thresholdLabelEl = document.getElementById('cart-drawer-threshold-label');
  var progressBarEl = document.getElementById('cart-drawer-progress-bar');
  var recommendationsEl = document.getElementById('cart-drawer-recommendations');
  var recommendationsListEl = document.getElementById('cart-drawer-recommendations-list');
  var checkoutEl = document.getElementById('cart-drawer-checkout');
  var footerNoteEl = document.getElementById('cart-drawer-footer-note');
  var undoEl = document.getElementById('cart-drawer-undo');
  var undoTextEl = document.getElementById('cart-drawer-undo-text');
  var undoBtn = document.getElementById('cart-drawer-undo-btn');

  var FREE_DELIVERY_CENTS = 19900;
  var isOpen = false;
  var lastCart = null;
  var lastFocused = null;
  var focusTrapHandler = null;
  var undoTimer = null;
  var removedSnapshot = null;
  var recommendationProductId = null;
  var recommendationCache = [];
  var recommendationRequest = 0;

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + String(path || '').replace(/^\/+/, '');
  }

  function escHtml(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function formatPrice(cents) {
    return window.AykahFormatMoney ? window.AykahFormatMoney(cents) : '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var value = typeof src === 'string' ? src : (src.url || src.src || '');
    if (!value) return '';
    return value + (value.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function trapFocus(container) {
    releaseFocus(container);
    focusTrapHandler = function (event) {
      if (event.key !== 'Tab') return;
      var focusable = container.querySelectorAll('a[href]:not([aria-disabled="true"]), button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', focusTrapHandler);
  }

  function releaseFocus(container) {
    if (!focusTrapHandler) return;
    container.removeEventListener('keydown', focusTrapHandler);
    focusTrapHandler = null;
  }

  function openDrawer() {
    if (isOpen) return;
    document.dispatchEvent(new CustomEvent('drawer:request-close', { detail: { except: 'cart' } }));
    isOpen = true;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-drawer-open');
    renderCart();
    window.setTimeout(function () {
      if (closeBtn) closeBtn.focus();
      trapFocus(drawer);
    }, 40);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    releaseFocus(drawer);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-drawer-open');
    var target = lastFocused && typeof lastFocused.focus === 'function' ? lastFocused : toggleBtn;
    window.setTimeout(function () { if (target) target.focus(); }, 260);
  }

  function updateCount(count) {
    if (!countEl) return;
    countEl.textContent = count === 0 ? 'Empty' : count + ' ' + (count === 1 ? 'item' : 'items');
  }

  function updateBadge(count) {
    if (!badgeEl) {
      var wrap = toggleBtn.querySelector('[data-icon-wrap]') || toggleBtn.querySelector('.relative');
      if (!wrap) return;
      badgeEl = document.createElement('span');
      badgeEl.id = 'cart-drawer-badge';
      badgeEl.style.cssText = 'position:absolute;top:-8px;right:-8px;width:16px;height:16px;background:#7D6040;color:#fff;font-size:10px;font-weight:600;border-radius:9999px;display:flex;align-items:center;justify-content:center;line-height:1;pointer-events:none';
      wrap.appendChild(badgeEl);
    }
    if (count > 0) {
      badgeEl.textContent = count;
      badgeEl.classList.remove('hidden');
      badgeEl.style.display = 'flex';
    } else {
      badgeEl.textContent = '';
      badgeEl.classList.add('hidden');
      badgeEl.style.display = 'none';
    }
  }

  function updateThreshold(total) {
    if (!thresholdEl || !thresholdLabelEl || !progressBarEl) return;
    var progress = Math.max(0, Math.min(100, (total / FREE_DELIVERY_CENTS) * 100));
    var complete = total >= FREE_DELIVERY_CENTS;
    thresholdEl.classList.toggle('is-complete', complete);
    thresholdLabelEl.textContent = complete
      ? 'Complimentary delivery applied'
      : formatPrice(Math.max(0, FREE_DELIVERY_CENTS - total)) + ' away from complimentary delivery';
    progressBarEl.style.width = progress + '%';
  }

  function updateFooter(cart) {
    if (subtotalEl) subtotalEl.textContent = formatPrice(cart.total_price);
    if (footerNoteEl) footerNoteEl.textContent = cart.item_count ? 'Taxes calculated at checkout' : 'Add something to see delivery';
    if (!checkoutEl) return;
    var disabled = cart.item_count === 0;
    checkoutEl.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    checkoutEl.setAttribute('tabindex', disabled ? '-1' : '0');
  }

  function cartItemMarkup(item) {
    var image = imageUrl(item.image, 200);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var unitPrice = item.final_price != null ? item.final_price : Math.round(item.final_line_price / Math.max(1, item.quantity));
    var showUnit = item.quantity > 1;
    var price = showUnit
      ? '<span class="aykah-cart-price-unit">' + formatPrice(unitPrice) + ' each</span><span class="aykah-cart-price-line">' + formatPrice(item.final_line_price) + '</span>'
      : '<span class="aykah-cart-price-line">' + formatPrice(item.final_line_price) + '</span>';
    var thumb = image
      ? '<img src="' + escHtml(image) + '" alt="' + escHtml(item.title) + '" loading="lazy">'
      : '';

    return '<div class="aykah-cart-item" data-cart-item="' + escHtml(item.key) + '">' +
      '<a class="aykah-cart-item-thumb" href="' + escHtml(item.url) + '">' + thumb + '</a>' +
      '<a class="aykah-cart-item-title" href="' + escHtml(item.url) + '">' + escHtml(item.product_title || item.title) + '</a>' +
      '<div class="aykah-cart-price">' + price + '</div>' +
      '<div class="aykah-cart-item-variant">' + escHtml(variant) + '</div>' +
      '<div class="aykah-cart-item-actions">' +
        '<div class="aykah-cart-stepper" aria-label="Quantity">' +
          '<button class="aykah-cart-qty-btn" type="button" data-action="minus" data-key="' + escHtml(item.key) + '" aria-label="Decrease quantity"' + ((item.quantity - qtyRuleFor(item).step) < qtyRuleFor(item).min ? ' disabled' : '') + '><span class="aykah-cart-icon aykah-cart-icon--minus" aria-hidden="true"></span></button>' +
          '<span class="aykah-cart-qty" aria-live="polite">' + item.quantity + '</span>' +
          '<button class="aykah-cart-qty-btn" type="button" data-action="plus" data-key="' + escHtml(item.key) + '" aria-label="Increase quantity"><span class="aykah-cart-icon aykah-cart-icon--plus" aria-hidden="true"></span></button>' +
        '</div>' +
        '<button class="aykah-cart-remove" type="button" data-key="' + escHtml(item.key) + '">Remove</button>' +
      '</div>' +
    '</div>';
  }

  function renderItems(cart) {
    if (!itemsEl || !emptyEl) return;
    if (cart.item_count === 0) {
      itemsEl.hidden = true;
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      return;
    }
    emptyEl.hidden = true;
    itemsEl.innerHTML = cart.items.map(cartItemMarkup).join('');
    itemsEl.hidden = false;
  }

  function showLoading(show) {
    if (loadingEl) loadingEl.hidden = !show;
  }

  function availableVariant(product) {
    var variants = product && product.variants ? product.variants : [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i].available !== false) return variants[i];
    }
    return null;
  }

  function recommendationMarkup(product) {
    var variant = availableVariant(product);
    if (!variant) return '';
    var image = imageUrl(product.featured_image || (product.images && product.images[0]), 140);
    var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    var meta = (variantTitle ? escHtml(variantTitle) + ' · ' : '') + formatPrice(variant.price != null ? variant.price : product.price);
    var thumb = image ? '<img src="' + escHtml(image) + '" alt="' + escHtml(product.title) + '" loading="lazy">' : '';

    return '<div class="aykah-cart-rec-row">' +
      '<a class="aykah-cart-rec-link" href="' + escHtml(product.url) + '">' +
        '<span class="aykah-cart-rec-thumb">' + thumb + '</span>' +
        '<span class="aykah-cart-rec-copy"><span class="aykah-cart-rec-name">' + escHtml(product.title) + '</span><span class="aykah-cart-rec-meta">' + meta + '</span></span>' +
      '</a>' +
      '<button class="aykah-cart-rec-add" type="button" data-variant-id="' + variant.id + '" aria-label="Add ' + escHtml(product.title) + ' to cart"><span class="aykah-cart-icon aykah-cart-icon--plus" aria-hidden="true"></span></button>' +
    '</div>';
  }

  function paintRecommendations(products) {
    recommendationCache = products || [];
    if (!recommendationsEl || !recommendationsListEl) return;
    var html = recommendationCache.map(recommendationMarkup).filter(Boolean).slice(0, 3).join('');
    recommendationsListEl.innerHTML = html;
    recommendationsEl.hidden = !html;
  }

  function fetchRecommendations(productId, intent) {
    return fetch(route('recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + encodeURIComponent(intent)), {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Recommendations request failed');
      return response.json();
    }).then(function (data) {
      return data && data.products ? data.products : [];
    });
  }

  function updateRecommendations(cart) {
    if (!recommendationsEl || !recommendationsListEl) return;
    if (!cart.items.length) {
      paintRecommendations(recommendationCache);
      return;
    }

    var productId = cart.items[0].product_id;
    if (recommendationProductId === productId && recommendationCache.length) {
      paintRecommendations(recommendationCache);
      return;
    }

    recommendationProductId = productId;
    var requestId = ++recommendationRequest;
    var cartProductIds = cart.items.map(function (item) { return Number(item.product_id); });

    fetchRecommendations(productId, 'complementary')
      .then(function (products) {
        if (products.length) return products;
        return fetchRecommendations(productId, 'related');
      })
      .then(function (products) {
        if (requestId !== recommendationRequest) return;
        var filtered = products.filter(function (product) {
          return cartProductIds.indexOf(Number(product.id)) === -1 && availableVariant(product);
        });
        paintRecommendations(filtered.slice(0, 3));
      })
      .catch(function () {
        if (requestId === recommendationRequest) paintRecommendations([]);
      });
  }

  function applyCart(cart) {
    lastCart = cart;
    updateBadge(cart.item_count);
    updateCount(cart.item_count);
    updateThreshold(cart.total_price);
    updateFooter(cart);
    renderItems(cart);
    updateRecommendations(cart);
  }

  function renderCart() {
    showLoading(true);
    return fetch(route('cart.js'), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        showLoading(false);
        applyCart(cart);
        return cart;
      })
      .catch(function () {
        showLoading(false);
      });
  }

  function changeLineItem(key, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    });
  }

  function addVariant(variantId, quantity, properties, sellingPlan) {
    var item = { id: Number(variantId), quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) item.properties = properties;
    if (sellingPlan) item.selling_plan = sellingPlan;
    return fetch(route('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [item] })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    });
  }

  function showUndo(item) {
    removedSnapshot = item;
    if (!undoEl || !undoTextEl) return;
    window.clearTimeout(undoTimer);
    undoTextEl.textContent = (item.product_title || item.title) + ' removed';
    undoEl.classList.add('is-visible');
    undoTimer = window.setTimeout(hideUndo, 6000);
  }

  function hideUndo() {
    if (undoEl) undoEl.classList.remove('is-visible');
    window.clearTimeout(undoTimer);
    undoTimer = null;
  }

  function removeItem(key, row) {
    if (!lastCart) return;
    var item = lastCart.items.find(function (entry) { return entry.key === key; });
    if (!item) return;
    if (row) row.classList.add('is-removing');
    window.setTimeout(function () {
      changeLineItem(key, 0).then(function (cart) {
        showUndo(item);
        applyCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
      }).catch(function () {
        if (row) row.classList.remove('is-removing');
      });
    }, 220);
  }

  function undoRemove() {
    if (!removedSnapshot) return;
    var item = removedSnapshot;
    removedSnapshot = null;
    hideUndo();
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? item.selling_plan_allocation.selling_plan.id
      : null;
    addVariant(item.variant_id, item.quantity, item.properties, sellingPlan)
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
        return renderCart();
      });
  }

  /* Purchase limits for a line. The drawer renders from /cart.js, which has no
     metafields, so header.liquid publishes the rules for whatever is in the
     cart and product-page.js merges in anything freshly added. Unknown product
     means min 1 / step 1, the previous behaviour. */
  function qtyRuleFor(item) {
    var map = window.AykahQtyRules || {};
    var r = map[String(item.product_id)] || {};
    var min = parseInt(r.min, 10);
    var step = parseInt(r.step, 10);
    var max = parseInt(r.max, 10);
    return {
      min: isNaN(min) || min < 1 ? 1 : min,
      step: isNaN(step) || step < 1 ? 1 : step,
      max: isNaN(max) || max < 1 ? 0 : max
    };
  }

  function changeQuantity(key, action, button) {
    if (!lastCart) return;
    var item = lastCart.items.find(function (entry) { return entry.key === key; });
    if (!item) return;
    var rule = qtyRuleFor(item);
    var ceiling = rule.max || 10 * rule.step;
    var quantity = action === 'plus'
      ? Math.min(ceiling, item.quantity + rule.step)
      : Math.max(rule.min, item.quantity - rule.step);
    if (quantity === item.quantity) return;
    var row = button.closest('[data-cart-item]');
    var buttons = row ? row.querySelectorAll('.aykah-cart-qty-btn') : [];
    for (var i = 0; i < buttons.length; i += 1) buttons[i].disabled = true;
    var qty = row ? row.querySelector('.aykah-cart-qty') : null;
    if (qty) qty.style.opacity = '0';
    changeLineItem(key, quantity).then(function (cart) {
      applyCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
    }).catch(function () {
      if (qty) qty.style.opacity = '1';
      for (var j = 0; j < buttons.length; j += 1) buttons[j].disabled = false;
    });
  }

  function addRecommendation(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;
    button.disabled = true;
    button.innerHTML = '<span class="aykah-cart-icon aykah-cart-icon--check" aria-hidden="true"></span>';
    button.classList.add('is-added');
    addVariant(variantId, 1).then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-drawer' } }));
      return renderCart();
    }).finally(function () {
      window.setTimeout(function () {
        button.disabled = false;
        button.innerHTML = '<span class="aykah-cart-icon aykah-cart-icon--plus" aria-hidden="true"></span>';
        button.classList.remove('is-added');
      }, 1200);
    });
  }

  toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (undoBtn) undoBtn.addEventListener('click', undoRemove);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) closeDrawer();
  });

  drawer.addEventListener('click', function (event) {
    var qtyBtn = event.target.closest('.aykah-cart-qty-btn');
    if (qtyBtn) {
      changeQuantity(qtyBtn.getAttribute('data-key'), qtyBtn.getAttribute('data-action'), qtyBtn);
      return;
    }
    var removeBtn = event.target.closest('.aykah-cart-remove');
    if (removeBtn) {
      removeItem(removeBtn.getAttribute('data-key'), removeBtn.closest('[data-cart-item]'));
      return;
    }
    var recBtn = event.target.closest('.aykah-cart-rec-add');
    if (recBtn) {
      addRecommendation(recBtn);
    }
  });

  if (checkoutEl) {
    checkoutEl.addEventListener('click', function (event) {
      if (checkoutEl.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      var href = checkoutEl.getAttribute('href');
      checkoutEl.innerHTML = '<span class="aykah-cart-spinner" aria-hidden="true"></span><span class="sr-only">Opening checkout</span>';
      window.setTimeout(function () { window.location.href = href; }, 400);
    });
  }

  var touchStartY = 0;
  var touchStartX = 0;
  var touchTracking = false;
  var mobileGestureTarget = drawer.querySelector('.aykah-cart-header');
  if (mobileGestureTarget) {
    mobileGestureTarget.addEventListener('touchstart', function (event) {
      if (window.innerWidth > 640 || !event.touches.length) return;
      touchStartY = event.touches[0].clientY;
      touchStartX = event.touches[0].clientX;
      touchTracking = true;
    }, { passive: true });
    mobileGestureTarget.addEventListener('touchend', function (event) {
      if (!touchTracking || window.innerWidth > 640 || !event.changedTouches.length) return;
      touchTracking = false;
      var dy = event.changedTouches[0].clientY - touchStartY;
      var dx = Math.abs(event.changedTouches[0].clientX - touchStartX);
      if (dy > 72 && dx < 60) closeDrawer();
    }, { passive: true });
  }

  document.addEventListener('cart:open', openDrawer);
  document.addEventListener('drawer:request-close', function (event) {
    if (event.detail && event.detail.except === 'cart') return;
    closeDrawer();
  });
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.source === 'cart-drawer') return;
    if (isOpen) renderCart();
    else {
      fetch(route('cart.js'), { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (cart) { updateBadge(cart.item_count); });
    }
  });

  fetch(route('cart.js'), { credentials: 'same-origin' })
    .then(function (response) { return response.json(); })
    .then(function (cart) { updateBadge(cart.item_count); updateCount(cart.item_count); })
    .catch(function () {});
})();
